import React from "react";
import {
  ColorList,
  Colors,
  LeftButton,
  MapSettingsStyleFormatingColors,
  RightButton,
} from "../styles";

type Props = {
  colorsArray: any[];
  paletteIndex: number;
  handlePickColor: (color: number) => void;
  handleColorChangePalette: (
    state: "left" | "right",
    paletteId: string
  ) => void;
  type: "sequential" | "qualitative";
  selectedFormatting?: string;
};

const SelectPalette: React.FC<Props> = ({
  handleColorChangePalette = () => {},
  selectedFormatting,
  handlePickColor,
  paletteIndex,
  colorsArray,
  type,
}) => {
  return (
    <MapSettingsStyleFormatingColors>
      {paletteIndex !== 0 && (
        <LeftButton
          onClick={() =>
            handleColorChangePalette("left", colorsArray[paletteIndex - 1].id)
          }
          cursor={"pointer"}
        />
      )}
      <ColorList $gap={type === "qualitative"}>
        {colorsArray[paletteIndex].colors.map((colors: any) => (
          <Colors
            $active={selectedFormatting === colors.key}
            $color={colors.hex}
            onClick={() =>
              type === "qualitative" && handlePickColor(colors.key)
            }
            key={colors.key}
            $sequential={type === "sequential"}
          />
        ))}
      </ColorList>
      {paletteIndex !== colorsArray.length - 1 && (
        <RightButton
          onClick={() =>
            handleColorChangePalette("right", colorsArray[paletteIndex + 1].id)
          }
          cursor={"pointer"}
        />
      )}
    </MapSettingsStyleFormatingColors>
  );
};

export default SelectPalette;
